<template>
  <div>
    <v-form ref="form">
      <v-dialog
        fullscreen
        value="true"
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-app-bar flag class="card-toolbar-title">
            <v-toolbar-title>
              Add Okta Federation SSO User Group
            </v-toolbar-title>
            <v-spacer />
            <v-btn icon @click.native="close">
              <v-icon>close</v-icon>
            </v-btn>
          </v-app-bar>

          <v-card-text>
            <okta-group-select :selected-name="selectedOktaGroup" @change="selectedOktaGroup = $event.value" />
            <v-autocomplete
              id="selectedUserGroup"
              v-model="selectedUserGroup"
              :items="userGroups"
              :filter="userGroupsFilter"
              :hint="selectedUserGroup.userGroupDesc"
              :rules="required"
              class="required"
              name="selectedUserGroup"
              label="Select User Group To Add"
              return-object
            >
              <template v-slot:selection="data">
                {{ data.item.userGroupName }}
              </template>
              <template v-slot:item="data">
                {{ data.item.userGroupName }} <span class="subheader">{{ data.item.userGroupDesc }}</span>
              </template>
            </v-autocomplete>
          </v-card-text>
          <v-card-actions>
            <div class="mx-auto">
              <v-btn color="primary" text @click.native="close">Cancel</v-btn>
              <v-btn color="primary" @click.native="save">Save</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import OktaGroupSelect from '@/components/manageOktaUsers/OktaGroupSelect'

export default {
  name: 'federation-table-modal',
  components: {
    OktaGroupSelect
  },
  props: {
    userGroups: Array,
    federationId: Number
  },
  data() {
    return {
      selectedUserGroup: {},
      selectedOktaGroup: '',
      required: [
        v => !!v || 'Required'
      ]
    }
  },
  methods: {
    ...mapActions('oktaFederations', ['addFederationSsoGroup']),
    userGroupsFilter(item, queryText, itemText) {
      const lower = val => val ? val.toLowerCase() : ''
      return lower(item.userGroupName).indexOf(lower(queryText)) > -1 || lower(item.userGroupDesc).indexOf(lower(queryText)) > -1
    },
    save() {
      if (this.$refs.form.validate()) {
        this.addFederationSsoGroup({ federationId: this.federationId, roleName: this.selectedOktaGroup, userGroupId: this.selectedUserGroup.userGroupId }).then(this.close, () => {})
      }
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>
